"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerificationServiceLive = void 0;
const HttpProvider_1 = require("../utils/HttpProvider");
const constants_1 = require("../utils/constants");
class VerificationServiceLive {
    sendEmail() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(constants_1.SEND_EMAIL, {});
            return response.data.status;
        });
    }
    verifyEmail(verificationToken) {
        return __awaiter(this, void 0, void 0, function* () {
            yield HttpProvider_1.httpProvider.get(verificationToken);
            return null;
        });
    }
    checkKycStatus(checkKycStatusData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (checkKycStatusData) {
                return true;
            }
            return false;
        });
    }
    sendEmailVerificationCode(sendEmailOtpData) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(constants_1.SEND_EMAIL_OTP, Object.assign({}, sendEmailOtpData));
            return response.data;
        });
    }
    verifyEmailWithCode(verifyEmailOtpData) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(constants_1.VERIFY_EMAIL_OTP, Object.assign({}, verifyEmailOtpData));
            return response.data;
        });
    }
}
exports.VerificationServiceLive = VerificationServiceLive;
//# sourceMappingURL=VerificationServiceLive.js.map